import { useAuth, useSnippets } from '@/hooks'
import { SnippetList } from '@/components/snippets'
import { formatDate, groupSnippetsByDate } from '@/lib/date'
import { useMemo } from 'react'

export const History = () => {
  const { user } = useAuth()
  const { snippets, loading, error, update, remove } = useSnippets({
    userId: user!.uid,
  })

  const groupedSnippets = useMemo(
    () => groupSnippetsByDate(snippets),
    [snippets]
  )

  const handleUpdate = async (id: string, content: string) => {
    await update(id, { content })
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">History</h1>
        <p className="text-gray-600">All your past snippets</p>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{error.message}</p>
        </div>
      )}

      {loading ? (
        <div className="text-center py-8 text-gray-600">Loading history...</div>
      ) : snippets.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <p>No snippets yet. Start adding some!</p>
        </div>
      ) : (
        <div className="space-y-8">
          {Array.from(groupedSnippets.entries()).map(([date, dateSnippets]) => (
            <div key={date}>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                {formatDate(date)} ({dateSnippets.length})
              </h2>
              <SnippetList
                snippets={dateSnippets}
                onUpdate={handleUpdate}
                onDelete={remove}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
